export * from './medical-personal-disease.interface';
export * from './medical-personal.redux';
export * from './record-medical-personal.interface';
